import { useContext, useMemo } from "react";
import { TranslatorContext } from "./TranslatorProvider";
/**
 * Get a translation function for a given namespace.
 *
 * @param namespace The namespace of translations to use.
 */
export default function useTranslate(namespace) {
    const translations = useContext(TranslatorContext);
    const t = useMemo(() => {
        if (translations[namespace] === undefined ||
            typeof translations[namespace] !== "object") {
            console.log(`%cTranslations: Undefined or invalid namespace: ${namespace}`, "color: orange");
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (key, data) => {
            const n = translations[namespace];
            const t = typeof n === "object" ? n[key] : undefined;
            if (t === undefined) {
                const k = `${namespace}.${key}`;
                console.log(`%cTranslations: Undefined translation: ${k}`, "color: orange");
                return k;
            }
            let f;
            if (Array.isArray(t)) {
                if (data && Object.prototype.hasOwnProperty.call(data, "n")) {
                    f = data.n === 1 ? t[0] : t[1];
                }
                else {
                    f = t[1];
                }
            }
            else {
                f = t;
            }
            if (f.includes("{{")) {
                return f.replace(/{{(\w+?)}}/g, (m, k) => { var _a, _b; return data ? (_b = (_a = data[k]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "" : ""; });
            }
            return f;
        };
    }, [translations, namespace]);
    return t;
}
